<template>
  <div v-if="link && domain" class="link">
    <slot
      ><a :href="link" target="_blank"
        >Öppan sidan <v-icon small class="ml-1" color="#1976d2">mdi-open-in-new</v-icon></a
      ></slot
    >
  </div>
</template>

<script>
const domains = {
  havsutsikt: 'https://www.havet.nu/havsutsikt/artikel/',
  havet: 'https://www.havet.nu/',
}

export default {
  name: 'PreviewLink',
  props: {
    domain: {
      type: String,
      required: true,
    },
    string: {
      type: String,
    },
  },
  computed: {
    link() {
      switch (this.domain) {
        case 'havsutsikt':
          return domains.havsutsikt + this.stringToUrl
        case 'havet':
          return domains.havet + this.stringToUrl
        default:
          return null
      }
    },
    stringToUrl() {
      if (!this.string) return null
      let res = this.string.toLowerCase()
      res = res.trim()
      res = res.replaceAll('ä', 'a')
      res = res.replaceAll('å', 'a')
      res = res.replaceAll('ö', 'o')
      res = res.replaceAll(' ', '-')
      res = res.replaceAll(':', '-')
      res = res.replaceAll('–', '-')
      res = res.replaceAll('/', '')
      res = res.replaceAll('\\', '')
      res = res.replaceAll('<', '')
      res = res.replaceAll('>', '')
      res = res.replaceAll('?', '')
      res = res.replaceAll('!', '')
      res = res.replaceAll('.', '-')
      res = res.replaceAll(',', '')
      return res
    },
  },
}
</script>

<style lang="less" scoped>
.link {
  display: flex;
  justify-content: flex-end;
  text-decoration: none;
}
</style>
